import { adminHttpClient } from '../../../commons/adminHttpClient'
import BenefitParticipationDecision from '../../../../domain/companies/BenefitParticipationDecision'

export interface PlanPeriodSummary {
  planPeriodId: string
  startDate: Date
  endDate?: Date
  allowEmployeeToSubmitExpense: boolean
  availableBalance: number
  allowanceYTD: number
  reimbursementYTD: number
  daysLeftForRequestingReimbursement: number | null
  hraDeductible: HraDeductible | null
  costSharingPercentage: number | null
  benefitParticipationDecision: BenefitParticipationDecision
}

interface HraDeductible {
  deductibleAmount: number
  accomplishedDeductibleAmount: number
  accomplishedDeductiblePercentage: number
}

const getBenefitSummaryApi = (planPeriodId?: string): Promise<PlanPeriodSummary[]> => {
  return adminHttpClient.get('/EEDashboard/GetReimbursed/Expense/AllowanceSummary', { planPeriodId })
}

export default getBenefitSummaryApi
